module.exports = __webpack_public_path__ + "static/media/suitcase.e64245e4.svg";